<template>
  <div>
  <div class="top-bar2">
      <div class="account-title">{{ $t('account.create_order') }}</div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>
